import CreateTabs from "common/components/createTabs";
import { JobOpeningIcon } from "services/Recruit/assets/svg/JobOpening";
import { useEffect, useState } from "react";
import { Box, Button, Spinner } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import CustomForm from "common/utils/customForm";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { postApi } from "common/services/api";
import { generateValidationSchema } from "services/Crm/utils";
import * as yup from "yup";
import { constant } from "common/constant";
import { globalStyles } from "common/theme/styles";
import { crmConstant } from "services/Crm/constant";
import { getApi } from "common/services/api";

const PropertyInformation = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const initialFieldValues = Object.fromEntries(
    (props?.propertyData?.fields || []).map((field) => [field?.name, ""])
  );

  const initialValues = {
    ...initialFieldValues,
    createBy: JSON.parse(localStorage.getItem("user"))._id,
  };

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: yup
      .object()
      .shape(generateValidationSchema(props?.propertyData?.fields)),

    onSubmit: (values, { resetForm }) => {
      AddData();
    },
  });

  const {
    errors,
    touched,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = formik;

  const AddData = async () => {
    try {
      setIsLoading(true);
      let response = await postApi("api/form/add", {
        ...values,
        moduleId: props?.propertyData?._id,
      });
      if (response.status === 200) {
        // props.setAction((pre) => !pre);
        toast.success(crmConstant.propertyAddedSuccessFully);
        navigate("/crm/products");
      }
    } catch (e) {
      toast.error(crmConstant.someThingWentWrong);
    } finally {
      setIsLoading(false);
      formik.resetForm();
    }
  };
  const handleBackPage = () => {
    navigate("/crm/products");
  };
  return (
    <>
      <Box className="commonPanelBody">
        <CustomForm
          moduleData={props.propertyData}
          values={values}
          setFieldValue={setFieldValue}
          handleChange={handleChange}
          handleBlur={handleBlur}
          errors={errors}
          touched={touched}
        />
      </Box>
      <Box className="createJobOpening-tabsPanelFooter">
        <Button
          size="sm"
          sx={{
            marginRight: 1,
            textTransform: "capitalize",
          }}
          variant="outline"
          onClick={handleBackPage}
          className="cancelBtn theme-btn2"
        >
          {crmConstant.back}
        </Button>
        <Button
          size="sm"
          className="theme-btn1"
          sx={{ textTransform: "capitalize" }}
          disabled={isLoading ? true : false}
          variant="brand"
          type="submit"
          onClick={handleSubmit}
        >
          {isLoading ? (
            <Spinner
              size={20}
              paddingRight={5}
              border={`3px solid ${globalStyles.colors.loaderBorder}`}
              borderTop={`1px solid ${globalStyles.colors.transparent}`}
            />
          ) : (
            ""
          )}{" "}
          {constant.save}
        </Button>
      </Box>
    </>
  );
};

const CreateProperty = () => {
  const navigate = useNavigate();
  const [propertyData, setPropertyData] = useState([]);


  const handleBackPage = () => {
    navigate("/crm/products");
  };

  const tabsData = [{ label: crmConstant.propertyInformation, Icon: JobOpeningIcon }];

  const panelsData = [<PropertyInformation propertyData={propertyData[0]} />];

  useEffect(() => {
    (async () => {
      const result = await getApi(`api/custom-field/?moduleName=Products`);
      setPropertyData(result?.data);
    })();
  }, []);

  return (
    <CreateTabs
      tabsData={tabsData}
      panelsData={panelsData}
      handleBackPage={handleBackPage}
      pageTitle={crmConstant.createProperty}
    />
  );
};

export default CreateProperty;
